<template>
  <div class="wrapper"
    :style="{height: list.length === 1 ? '100vh':'100%'}">
    <!-- ID CARD -->
    <div class="card"
      v-for="(item, key) in list" :key="key"
      :style="{ 
        backgroundImage: 'url(' + dataBgImage +')',
        backgroundColor: dataBgImage !== null ? 'transparent' : 'red',
      }">
      <div 
        class="card-inline"
       >
        <div class="card-wrapper" 
          v-for="(x, i) in [null,null]" :key="i" 
        >
          <div class="card-header-logo">
            <template v-if="configData !== null">
              <p v-if="configData.logoHeaderUrl === null">( Logo Header )</p>
              <div v-else 
                class="img-logo-header" 
                :style="{ backgroundImage: 'url(' + configData.logoHeaderUrl + ')' }"> 
              </div>
          </template>
          </div>
          <div class="card-profile">
            <div class="card-profile-photo">
              <div 
                v-if="item.urlPhoto === null || item.urlPhoto === ''"
                :style="{
                  backgroundImage: 'url(' + broken +')'
                }"
                class="photo-id-card"></div>
              <div 
                v-else
                :style="{
                  backgroundImage: 'url(' + item.urlPhoto +')'
                }"
                class="photo-id-card"> </div>
            </div>
            <div class="card-profile-info">
              <div><strong>{{ item.firstname }} {{ item.lastname }}</strong></div>
              <div>{{ item.company }}</div>
            </div>
          </div>
          <div class="card-footer-logo">
            <div class="card-footer-logo-1">
              <template v-if="configData !== null">
                <p v-if="configData.logoFooterUrl === null">( Logo Footer )</p>
                <div v-else 
                  class="img-logo-footer-1" 
                  :style="{ backgroundImage: 'url(' + configData.logoFooterUrl + ')' }">
                </div>
              </template>
            </div>
            <div class="card-footer-logo-2">
              <template v-if="configData !== null">
                <p v-if="configData.logoSponsorUrl === null">( Logo Sponsor )</p>
                <div v-else 
                  class="img-logo-footer-2" 
                  :style="{ backgroundImage: 'url(' + configData.logoSponsorUrl + ')' }">
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
  import {getAttendee} from '@/factory/report'
  import {getNameTagConfig} from '@/factory/configuration'
  import broken from '@/assets/images/default-photo.png'

  export default {
    data () {
      return {
        list: [],
        configData: null,
        broken,
        dataBgImage: null
      }
    },
    mounted () {
      this.$nextTick(()=>{
        this.getConfig()
      })
    },
    created () {
      this.$nextTick(()=>{
        this.init()
      })
    },
    computed: {
      queryRoute () { return this.$route.query },
      attendeeId () { return this.$route.params.attendeeId || null } ,
      eventId () { return this.queryRoute.eventId || null } 
    },
    methods: {
      init () {
        getAttendee(this.queryRoute)
          .then(res => {
            if(this.attendeeId !== null) {
              this.list = res.data.filter(x => {
                return x.attendeeId === this.attendeeId
              })
            }else {
              this.list = res.data
            }
          })
          .catch(() => {})
      },
       getConfig () {
        getNameTagConfig(this.eventId)
          .then(res => {
            this.configData = res
            this.dataBgImage = res.backgroundUrl
          })
          .then(()=> {
             setTimeout(() => {
              window.print()
            }, 3000);
          })
          .catch(e => void e)
      }
    }
  }
</script>
<style lang="scss">
  body { margin: 0 }
  .wrapper {
    width: 100%;
    height: 100%;
    background-color: #292a2d;
  }
   // ID Card
  .card {
    z-index: -1; // under layer
    position: relative;
    width: 18cm;
    height: 13.9cm;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    margin: 0 auto 0.5cm auto; 
    display: list-item;
    flex-direction: row;
    .card-inline { display: inline-flex; }
  }
  .card-wrapper {
    position: relative;
    width: 9cm;
    height: 13.9cm;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    .card-header-logo {
      display: none !important; // only for apmf
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 14%;
      background-color: transparent;
      p {
        text-align: center;
        padding-top: 14px;
      }
      .img-logo-header {
        width: 100%;
        height: 61px;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        margin-top: 16px;
      }
    }
    .card-profile {
      position: relative;
      width: 100%;
      height: auto;
      margin: 0;
      padding-top: 2.2cm;
      .card-profile-photo {
        position: relative;
        width: 6.2cm;
        height: 6.2cm;
        border-radius: 50%;
        margin: 0 auto;
        background-color: #fff;
        text-align: center;
        .photo-id-card {
          position: relative;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          margin: 0 auto;
          background-repeat: no-repeat;
          background-size: contain;
          background-position: center;
        }
      }
      .card-profile-info {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 88%;
        height: 2.7cm;
        font-weight: 400;
        font-size: 18px;
        font-family: "Poppins", "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
        background-color: #fff;
        border-radius: 12px;
        margin: 0.35cm auto;
        padding-bottom: 2px 2px;
        :nth-child(1) {
          color: #f33552;
          font-size: 20px;
          text-align: center;
        }
        :nth-child(2) {
          color: #282727;
          font-size: 12px;
          text-align: center;
        }
      }
    }
    .card-footer-logo {
      display: none !important; // only for apmf
      position: relative;
      width: 100%;
      height: 15%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: row;
      .card-footer-logo-1, .card-footer-logo-2 {
        width: 50%;
        height: 100%;
        display: flex;
        align-items: center;
        padding: 8px;
        p {
          text-align: center;
          padding-top: 14px;
          font-size: 8px;
          color: #fff;
        }
        .img-logo-footer-1, .img-logo-footer-2 {
          width:100%;
          height: 50%;
          background-repeat: no-repeat;
          background-size: contain;
          padding: 8px;
        }
        .img-logo-footer-1 {
          background-position: left;
        }
        .img-logo-footer-2 {
          background-position: right;
        }
      }
      .card-footer-logo-1 {
        justify-content: flex-start;
      }
      .card-footer-logo-2 {
        justify-content: flex-end;
      }
    }
  }
  // Media Print
  @media print {
    @page {
      size: A4;
      -webkit-print-color-adjust: exact !important;   /* Chrome, Safari, Edge */
      color-adjust: exact !important;    /* Firefox */ 
    }
    body {
      column-count: 1;
      -webkit-column-count: 1;
      -moz-column-count: 1;
    }
    .wrapper {
      background-color: #fff;
    }
    .card, .card-wrapper {
      display: block;
      page-break-before: left;
      z-index: 1;
    }
  }
</style>